import '../../react-commons/utils/kotlin-extensions';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Application } from './ui/pages/Application';

// Create main element
const mainElement = document.createElement('div');
mainElement.style.width = '100%';
mainElement.style.height = '100%';
document.body.appendChild(mainElement);

// Render components
const root = ReactDOM.createRoot(mainElement);

root.render(
    <StrictMode>
        <Application />
    </StrictMode>,
);
